import UnauthenticatedService from "./UnauthenticatedService";

class AuthService {
  async login(username, password) {
    return UnauthenticatedService.post("/api/login", {
      body: JSON.stringify({
        user: {
          username,
          password,
        },
      }),
    });
  }

  logout() {
    return Promise.resolve(true);
  }
}

export default new AuthService();
